import Vue from 'vue';


export default () => Vue.$http
    .get('Wordboards/count');



// WEBPACK FOOTER //
// ./src/services/wordboard/countAll.js